import { Component, inject, Input, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Record } from 'src/app/models/record';
import { CitationFacade } from '../../../_core/state/dialogs/citation/citation.facade';

@Component({
  selector: 'app-citation-button',
  templateUrl: './citation-button.component.html',
  styleUrls: ['./citation-button.component.scss'],
})
export class CitationButtonComponent implements OnInit {
  private readonly citationFacade = inject(CitationFacade);

  @Input()
  record: Record;

  constructor(protected dialog: MatDialog) {}

  ngOnInit() {}

  openCitationDialog() {
    this.citationFacade.openCitationModal(this.record);
  }
}
